

import React, { useEffect } from "react";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { useSelector } from "react-redux";
import { formatPrice } from "../Utility/Utility";

const RightCart = ({
  productReducer,
  updatedData,
  setConvenienceFee,
  setGst,
}) => {
  const translation = getTranslationData();

  // product id & mapping data
  // const productId = productReducer?.productReducerDisocount?.id;

  // const ClientProductMappingData = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer.data?.[0]?.clientProductMapping
  // );
  const productMapping = productReducer?.productReducer;
  // convenience fee % and gst %
  const convenienceFeePercent = Number(productMapping?.convenienceFee) || 0;
  const gstPercent = Number(productMapping?.gst) || 0;
  const customerdis = Number(productMapping?.customerDiscount) || 0;

  // base calculations
  let totalDenomination = 0;
  let totalQuantity = 0;
  let basePayableAmount = 0;
  let convenienceFeeAmount = 0;
  let gstAmount = 0;
  updatedData?.forEach((item) => {
    const qty = item.quantity || 0;

    totalDenomination += item.denomination * qty;
    totalQuantity += qty;
    basePayableAmount += item.you_pay * qty;
    const convPerItem = (item.you_pay * convenienceFeePercent) / 100;
    convenienceFeeAmount += convPerItem * qty;

    const gstPerItem = (convPerItem * gstPercent) / 100;
    gstAmount += gstPerItem * qty;
  });

  const totalDiscount = (totalDenomination * customerdis)/100;
  const totalPayableAmount =
(totalDenomination - totalDiscount) + convenienceFeeAmount + gstAmount;
  useEffect(() => {
    if (setConvenienceFee)
      setConvenienceFee((convenienceFeeAmount));
    if (setGst) setGst((gstAmount));
  }, [convenienceFeeAmount, gstAmount, setConvenienceFee, setGst]);

 

  return (
    <div className="mt-3">
      <div className="bg-white rightCart bnb">
        <div className="info p-md-4 p-2 pt-2 pb-2">
          {/* Total Giftcards */}
          <div className="d-flex justify-content-between jlkk pb-2">
            <div className="mr-4 lsss2">
               {totalQuantity} {translation?.giftCard}{totalQuantity >1 ? 's':''}
            </div>
            <div className="lsss3">₹{totalDenomination.toLocaleString()}</div>
          </div>

          {customerdis > 0 && (
            <div className="d-flex justify-content-between jlkk pb-2">
              <div className="mr-4 lsss2">{translation?.discount}</div>
              <div className="lsss3">₹{formatPrice(totalDiscount)}</div>
            </div>
          )}

          {/* Convenience Fee + GST */}
          {(convenienceFeeAmount > 0 || gstAmount > 0) && (
            <div className="d-flex justify-content-between jlkk pb-2">
              <div className="mr-4 lsss2">
                {convenienceFeeAmount > 0 && (
                  <>
                    <span className="d-block">
                      {translation?.convenience_fe}
                    </span>
                    <span>{convenienceFeePercent}%</span>
                  </>
                )}
                {gstAmount > 0 && <span>{translation?.plus_gst}</span>}
              </div>
              <div className="lsss3">
                ₹{formatPrice(convenienceFeeAmount + gstAmount)}
              </div>
            </div>
          )}

          {/* Total Amount */}
          <div className="d-flex justify-content-between jlkk">
            <div className="mr-4 lsss3 lssss4">{translation?.totalAmount}</div>
            <div className="lsss3">₹{formatPrice(totalPayableAmount)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightCart;
